(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = () => {
      for (const compare of document.querySelectorAll('[data-mt-compare]')) {
        if (compare.dataset.ready) continue;
        compare.dataset.ready = 'true';
        const range = compare.querySelector('[data-mt-compare-range]');
        if (!range) continue;
        range.addEventListener('input', () => {
          compare.setAttribute('data-touched', '');
          compare.style.setProperty('--mt-pos', `${range.value}%`);
        });
        range.addEventListener('pointerdown', () => compare.setAttribute('data-dragging', ''));
        for (const type of ['pointerup', 'pointercancel', 'blur']) {
          range.addEventListener(type, () => compare.removeAttribute('data-dragging'));
        }
      }
    };
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-ofertas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      const bar = section?.querySelector('[data-mt-home-sticky]');
      if (!bar) return;
      // Fuera de la sección, para que ningún contenedor del tema cambie su posición fija.
      document.body.append(bar);
      const hero = document.querySelector('#MainContent > .shopify-section');
      const mobile = window.matchMedia('(max-width: 989px)');
      let pastHero = !hero || hero === section;
      let offersOnScreen = false;
      const update = () => {
        bar.hidden = !(mobile.matches && pastHero && !offersOnScreen);
      };
      if (hero && hero !== section) {
        new IntersectionObserver(([entry]) => {
          pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          update();
        }).observe(hero);
      }
      new IntersectionObserver(([entry]) => {
        offersOnScreen = entry.isIntersecting;
        update();
      }).observe(section);
      mobile.addEventListener('change', update);
    };

    /* Selector de lista (móvil): la opción elegida cambia la foto, el producto y el precio del botón. */
    const initPicker = (section) => {
      const picker = section?.querySelector('[data-mt-picker]');
      if (!picker || picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      const button = picker.querySelector('[data-mt-picker-add]');
      const price = picker.querySelector('[data-mt-price]');
      const stages = [...picker.querySelectorAll('[data-mt-stage]')];
      picker.addEventListener('change', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (!input || !button) return;
        button.dataset.variantId = input.value;
        button.dataset.mtUnits = input.dataset.mtUnits || '1';
        button.disabled = input.disabled;
        button.setAttribute('aria-disabled', String(input.disabled));
        if (price) {
          price.textContent = `· ${input.dataset.price}`;
          if (document.documentElement.classList.contains('mt-motion-on')) {
            price.classList.remove('is-changing');
            void price.offsetWidth;
            price.classList.add('is-changing');
          }
        }
        for (const img of stages) img.hidden = img.dataset.mtStage !== input.value;
      });
    };

    for (const section of document.querySelectorAll('.mt-ofertas-section')) {
      init(section);
      initPicker(section);
    }

    /* Editor de Shopify: al volver a pintar la sección se quita la barra anterior */
    document.addEventListener('shopify:section:unload', (event) => {
      const id = event.detail?.sectionId;
      for (const bar of document.querySelectorAll('body > [data-mt-home-sticky]')) {
        if (!id || bar.dataset.sectionId === id) bar.remove();
      }
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target.classList.contains('mt-ofertas-section')) return;
      init(event.target);
      initPicker(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-producto"]) return;
  try {
    
  (() => {
  const init = (section) => {
    if (!section || section.dataset.ready) return;
    section.dataset.ready = 'true';

    /* Selector de ofertas → botón principal y barra fija */
    const choices = section.querySelector('[data-mt-choices]');
    const mainAdd = section.querySelector('[data-mt-main-add]');
    const stickyAdd = section.querySelector('[data-mt-sticky-add]');
    const stickyName = section.querySelector('[data-mt-sticky-name]');
    const stickyPrice = section.querySelector('[data-mt-sticky-price]');
    const priceLabel = section.querySelector('[data-mt-price]');

    const apply = (input) => {
      if (!input) return;
      for (const button of [mainAdd, stickyAdd]) {
        if (!button) continue;
        button.dataset.variantId = input.value;
        button.dataset.mtUnits = input.dataset.mtUnits || '1';
        button.disabled = input.disabled;
        button.setAttribute('aria-disabled', String(input.disabled));
      }
      if (priceLabel) {
        priceLabel.textContent = `· ${input.dataset.price}`;
        if (document.documentElement.classList.contains('mt-motion-on')) {
          priceLabel.classList.remove('is-changing');
          void priceLabel.offsetWidth;
          priceLabel.classList.add('is-changing');
        }
      }
      if (stickyName) stickyName.textContent = input.dataset.name || '';
      if (stickyPrice) stickyPrice.textContent = input.dataset.price || '';
    };

    choices?.addEventListener('change', (event) => {
      const input = event.target.closest('input[type="radio"]');
      if (input) apply(input);
    });
    apply(choices?.querySelector('input:checked'));

    /* Galería: índice y miniaturas */
    const track = section.querySelector('[data-mt-gallery-track]');
    const counter = section.querySelector('[data-mt-gallery-index]');
    const thumbs = [...section.querySelectorAll('[data-mt-thumb]')];
    if (track) {
      const slides = [...track.children];
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const index = Number(entry.target.dataset.index || 0);
            if (counter) counter.textContent = String(index + 1);
            thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
          }
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
      for (const thumb of thumbs) {
        thumb.addEventListener('click', () => {
          const slide = slides[Number(thumb.dataset.mtThumb)];
          if (!slide) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    }

    /* Pestañas accesibles */
    const tabs = section.querySelector('[data-mt-tabs]');
    if (tabs) {
      const tabButtons = [...tabs.querySelectorAll('[role="tab"]')];
      const select = (tab, focus) => {
        for (const other of tabButtons) {
          const selected = other === tab;
          other.setAttribute('aria-selected', String(selected));
          other.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        }
        if (focus) tab.focus();
      };
      tabs.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) select(tab, false);
      });
      tabs.addEventListener('keydown', (event) => {
        const current = tabButtons.indexOf(document.activeElement);
        if (current < 0) return;
        let next = null;
        if (event.key === 'ArrowRight') next = tabButtons[(current + 1) % tabButtons.length];
        if (event.key === 'ArrowLeft') next = tabButtons[(current - 1 + tabButtons.length) % tabButtons.length];
        if (event.key === 'Home') next = tabButtons[0];
        if (event.key === 'End') next = tabButtons[tabButtons.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next, true);
      });
    }

    /* Barra fija (solo móvil): visible siempre que el botón principal no está en pantalla, también
       antes de llegar a él (quien entra desde un anuncio ve el precio y la compra desde el principio). */
    const sticky = section.querySelector('[data-mt-sticky]');
    const anchor = mainAdd;
    if (sticky && anchor) {
      // Fuera de la sección, para que ningún contenedor del tema cambie su posición fija.
      document.body.append(sticky);
      const mobile = window.matchMedia('(max-width: 989px)');
      let offscreen = false;
      const update = () => {
        sticky.hidden = !(mobile.matches && offscreen);
      };
      const observer = new IntersectionObserver(([entry]) => {
        offscreen = !entry.isIntersecting;
        update();
      });
      observer.observe(anchor);
      mobile.addEventListener('change', update);
    }
  };

  for (const section of document.querySelectorAll('.mt-producto')) init(section);

  /* Editor de Shopify: al volver a pintar la sección, se reinicia y se quita la barra fija anterior */
  document.addEventListener('shopify:section:unload', (event) => {
    const id = event.detail?.sectionId;
    for (const bar of document.querySelectorAll('body > [data-mt-sticky]')) {
      if (!id || bar.dataset.sectionId === id) bar.remove();
    }
  });
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('.mt-producto'));
  });
  })();

  } catch(e) { console.error(e); }
})();
})();
